<template>
  <div class="home">
    <Navbar />
    <vue-headful title="BLOCK LIST" />

    <fish-segment>
      <fish-loader :active="isLoading"></fish-loader>

      <fish-card fluid color="red">
        <div slot="header">DANH SÁCH KHÁCH HÀNG BLOCK</div>
        <a-table
          rowKey="Index"
          size="small"
          :columns="columns"
          :data-source="TBLdata"
          :pagination="false"
          :scroll="{ x: 600 }"
        >
          <span slot="SMS_All_Counter" slot-scope="text">{{ text |toNumber}}</span>
          <span slot="SMS_Counter" slot-scope="text,record">
            <span v-if="record.Customer_Status=='blacklist'" style="color:red">{{ text |toNumber}}</span>
            <span v-else>{{ text |toNumber}}</span>
          </span>
          <span slot="SMS_Day_Counter" slot-scope="text,record">
            <span v-if="record.Customer_Status=='block'" style="color:orange">{{ text |toNumber}}</span>
            <span v-else>{{ text |toNumber}}</span>
          </span>
          <template slot="Note" slot-scope="text,record">
            <a-input
              v-if="'editable' in record && record.editable==true"
              style="margin: -5px 0"
              :value="text"
              @change="e => handleChange(e.target.value, record.User_ID)"
            />
            <span v-else>{{ text }}</span>
          </template>
          <span slot="Modified_Date" slot-scope="text">{{ text | moment("DD/MM/YYYY HH:mm:ss")}}</span>
          <span slot="Customer_Status" slot-scope="text">
            <a-tag
              :key="text"
              :color="text=='avaiable'?'green':
            text=='block'?'orange':'red'"
            >
              {{ text=='avaiable'?'BÌNH THƯỜNG':
              text=='block'?'TẠM KHÓA':'ĐÃ KHÓA'
              }}
            </a-tag>
          </span>
          <template slot="action" slot-scope="text, record">
            <span v-if="record.editable">
              <a-popconfirm title="Lưu thay đổi?" @confirm="() => CustSave(record.User_ID)">
                <a-button size="small" type="primary">
                  <i class="fa fa-floppy-o" aria-hidden="true"></i> 
                  LƯU
                </a-button>
              </a-popconfirm>
              <span style="padding: 0 3px">
                <a-button size="small" @click="() => CustCancel(record.User_ID)" type="danger">
                  <i class="fa fa-ban" aria-hidden="true"></i>
                  HỦY
                </a-button>
              </span>
            </span>
            <span style="padding-right:3px" v-else>
              <a-button
                size="small"
                :disabled="editingCust !== ''"
                @click="() => CustEdit(record.User_ID)"
                type="primary"
              >
                <i class="fa fa-pencil-square-o" aria-hidden="true"></i>
                SỬA
              </a-button>
              <!-- <a :disabled="editingCust !== ''" @click="() => CustEdit(record.User_ID)">SỬA</a> -->
            </span>
            <a-popconfirm
              v-if="record.Customer_Status!=='blacklist'"
              title="Khóa không cho khách hàng tham gia chương trình!"
              @confirm="() => CustChangeStatus(record.User_ID)"
            >
              <a-button size="small" type="danger">KHÓA</a-button>
            </a-popconfirm>
            <a-button v-else :disabled="true" size="small" type="danger">KHÓA</a-button>
          </template>
        </a-table>
        <div v-if="TBLdata && TBLdata.length>0" style="text-align:right;padding-top:5px">
          <a-pagination size="small" :pageSize="100" @change="onChange" :total="TBLdataTotal" />
        </div>
      </fish-card>
      <br />
      <fish-row>
        <fish-col span="12"></fish-col>
        <fish-col span="12">
          <fish-row>
            <fish-col span="12">
              <a-tag color="orange">TẠM KHÓA</a-tag>: Khách hàng trúng thưởng quá {{this.$PRJ_DAY_TOPUP}} lần/ngày (Reset sau 24h mỗi ngày)
            </fish-col>
            <fish-col span="12">
              <a-tag color="red">ĐÃ KHÓA</a-tag>: Khách hàng trúng thưởng quá {{this.$PRJ_MAX_TOPUP}} lần/toàn chương trình
            </fish-col>
          </fish-row>
        </fish-col>
      </fish-row>
    </fish-segment>
  </div>
</template>

<script>
// @ is an alias to /src
import Navbar from "@/components/Navbar.vue";
import { mapActions } from "vuex";
const moment = require("moment");
export default {
  name: "BlackList",
  components: {
    Navbar,
  },
  mounted() {
    this.fillData();
  },
  data() {
    return {
      isLoading: false,
      page: 1,
      editingData: "",
      editingCust: "",
      columns: [
        { title: "#", dataIndex: "Index", key: "Index",width:"50px" },
        { title: "KHÁCH HÀNG", dataIndex: "User_ID", key: "User_ID" },
        {
          title: "TỔNG SMS",
          dataIndex: "SMS_All_Counter",
          key: "SMS_All_Counter",
          scopedSlots: { customRender: "SMS_All_Counter" },
        },
        {
          title: "SMS TOPUP HÔM NAY",
          dataIndex: "SMS_Day_Counter",
          key: "SMS_Day_Counter",
          scopedSlots: { customRender: "SMS_Day_Counter" },
        },
        {
          title: "TỔNG SMS TOPUP",
          dataIndex: "SMS_Counter",
          key: "SMS_Counter",
          scopedSlots: { customRender: "SMS_Counter" },
        },
        {
          title: "TRẠNG THÁI",
          dataIndex: "Customer_Status",
          key: "Customer_Status",
          scopedSlots: { customRender: "Customer_Status" },
        },
        {
          title: "NGÀY THAY ĐỔI",
          dataIndex: "Modified_Date",
          key: "Modified_Date",
          scopedSlots: { customRender: "Modified_Date" },
        },
        {
          title: "GHI CHÚ",
          dataIndex: "Note",
          key: "Note",
          scopedSlots: { customRender: "Note" },
        },
        {
          title: "CHỨC NĂNG",
          dataIndex: "action",
          scopedSlots: { customRender: "action" },
        },
      ],
      TBLdata: [],
      TBLdataTotal: 0,
    };
  },
  methods: {
    // Only show error after a field is touched.
    ...mapActions(["API_BlockList", "API_ChangeStatus", "API_ChangeNote"]),
    async fillData() {
      try {
        this.isLoading = true;
        let oData = await this.API_BlockList(this.page);
        if (oData && oData.data.State == 1) {
          let ind = 0;
          this.TBLdataTotal = oData.data.Message.Total;
          this.TBLdata = [];
          for (let oCustomer of oData.data.Message.Data) {
            let Customer_Status = "";
            let Modified_Date = null;
            if (oCustomer.IsBlackList) {
              Customer_Status = "blacklist";
              Modified_Date = oCustomer.BlackList_Date;
            } else if (oCustomer.IsBlock) {
              Customer_Status = "block";
              Modified_Date = oCustomer.Block_Date;
            }
            let CustData = {
              Index: ++ind,
              User_ID: oCustomer.User_ID,
              SMS_All_Counter: oCustomer.SMS_All_Counter,
              SMS_Counter: oCustomer.SMS_Counter,
              SMS_Day_Counter: oCustomer.SMS_Day_Counter,
              Customer_Status: Customer_Status,
              Modified_Date: Modified_Date,
              Note: oCustomer.Note,
            };
            this.TBLdata.push(CustData);
          }
        } else if (oData && oData.data.State == 2) {
          this.$message.success(oData.data.Message, 3000);
        }

        this.isLoading = false;
      } catch (err) {
        console.log(err.Message);
        this.$message.success(
          "Có lỗi xảy ra trong quá trình lấy dữ liệu!",
          3000
        );
        this.isLoading = true;
      }
    },
    handleChange(value, key) {
      const target = this.TBLdata.find((st) => st.User_ID == key);
      if (target) {
        this.editingData = value;
      }
    },
    CustEdit(key) {
      let nData = [...this.TBLdata];
      const target = nData.find((st) => st.User_ID == key);
      this.editingCust = key;
      if (target) {
        target.editable = true;
        this.TBLdata = nData;
      }
    },
    async CustSave(key) {
      let nData = [...this.TBLdata];
      const target = nData.find((st) => st.User_ID == key);
      if (target) {
        try {
          this.isLoading = true;
          let oCustomerData = await this.API_ChangeNote({
            Phone: key,
            Note: this.editingData,
          });
          if (
            oCustomerData &&
            oCustomerData.data &&
            oCustomerData.data.State == 1
          ) {
            oCustomerData = oCustomerData.data.Message;
            let Customer_Status = "";
            let Modified_Date = null;
            if (oCustomerData.IsBlackList) {
              Customer_Status = "blacklist";
              Modified_Date = oCustomerData.BlackList_Date;
            } else if (oCustomerData.IsBlock) {
              Customer_Status = "block";
              Modified_Date = oCustomerData.Block_Date;
            }
            target.SMS_All_Counter = oCustomerData.SMS_All_Counter;
            target.SMS_Counter = oCustomerData.SMS_Counter;
            target.SMS_Day_Counter = oCustomerData.SMS_Day_Counter;
            target.Customer_Status = Customer_Status;
            target.Modified_Date = Modified_Date;
            target.Note = oCustomerData.Note;
            this.editingCust = "";
            this.editingData = "";
            delete target.editable;
            this.TBLdata = nData.sort(function (a, b) {
            return moment(a.Modified_Date) - moment(b.Modified_Date);
          });
          } else {
            this.$message.error(oCustomerData.data.Message, 3000);
          }
          this.isLoading = false;
        } catch (err) {
          console.log("Change Note Err:" + err.message);
          this.isLoading = false;
        }
      }
      this.editingCust = "";
    },
    CustCancel(key) {
      let nData = [...this.TBLdata];
      const target = nData.find((st) => st.User_ID == key);
      this.editingCust = "";
      if (target) {
        delete target.editable;
        this.TBLdata = nData;
      }
    },
    async CustChangeStatus(Phone) {
      let changeStatus = await this.API_ChangeStatus(Phone);
      if (changeStatus && changeStatus.data && changeStatus.data.State == 1) {
        let oCust = this.TBLdata.find((st) => st.User_ID == Phone);
        if (oCust) {
          let Customer_Status = "";
          let Modified_Date = null;
          if (changeStatus.data.Message.IsBlackList) {
            Customer_Status = "blacklist";
            Modified_Date = changeStatus.data.Message.BlackList_Date;
          } else if (changeStatus.data.Message.IsBlock) {
            Customer_Status = "block";
            Modified_Date = changeStatus.data.Message.Block_Date;
          }

          oCust.SMS_All_Counter = changeStatus.data.Message.SMS_All_Counter;
          oCust.SMS_Counter = changeStatus.data.Message.SMS_Counter;
          oCust.SMS_Day_Counter = changeStatus.data.Message.SMS_Day_Counter;
          oCust.Customer_Status = Customer_Status;
          oCust.Modified_Date = Modified_Date;
          oCust.Note = changeStatus.data.Message.Note;
        }
      } else {
        this.$message.success(changeStatus.data.Message, 3000);
      }
    },
    async onChange(data) {
      if (data > 0) this.page = data;
      this.fillData();
    },
  },
};
</script>